import { useContext, useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import { Storefront, EmojiEvents, ConfirmationNumber, Redeem, AccountBalanceWallet, Print, Loyalty } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { DataContext } from "../../context/DataContext";
import { clubPost } from "./clubApi";
import { consoleColors } from "../admin/consoleTheme";
import { formatAmount } from "../../include/money";
import { hasMenu } from "../../include/staffAccess";

const cards = [
  { key: "stores", menu: "stores", label: "Stores in this club", to: "/club/stores", icon: Storefront, tint: "#e4f4fd", color: "#21a7ec" },
  { key: "draws", menu: "luckydraw", label: "Lucky Draw Coupons", to: "/club/luckydraw", icon: EmojiEvents, tint: "#fef3c7", color: "#b45309" },
  { key: "issued", menu: "luckydraw", label: "Issued coupons", to: "/club/luckydraw", icon: ConfirmationNumber, tint: "#e0e7ff", color: "#4338ca" },
  { key: "winners", menu: "luckydraw", label: "Winners", to: "/club/luckydraw", icon: Redeem, tint: "#dcfce7", color: "#15803d" },
  { key: "prints", menu: "print", label: "Loyalty card prints", to: "/club/print", icon: Print, tint: "#fae8ff", color: "#a21caf" },
  { key: "pending_prints", menu: "print", label: "Prints in progress", to: "/club/print", icon: Print, tint: "#ffedd5", color: "#c2410c" },
  { key: "loyalty_uses", menu: "loyaltyhistory", label: "Loyalty points used", to: "/club/loyalty-history", icon: Loyalty, tint: "#e0f2fe", color: "#0369a1" },
];

export default function ClubHome() {
  const navigate = useNavigate();
  const { clubData } = useContext(DataContext);
  const clubId = clubData?.club_info?.club_id;
  const [stats, setStats] = useState({});

  useEffect(() => {
    if (!clubId) return;
    clubPost("CLUB_HOME", { club_id: clubId }).then((result) => {
      if (result.status === "200") setStats(result.data || {});
    });
  }, [clubId]);

  return (
    <Box sx={{ p: { xs: 2, md: 3 } }}>
      <Box sx={{ background: "#fff", border: `1px solid ${consoleColors.line}`, borderRadius: 2.5, p: 2, mb: 2, display: "flex", justifyContent: "space-between", gap: 2, flexWrap: "wrap" }}>
        <Box>
          <Typography sx={{ fontSize: 18, fontWeight: 750 }}>{stats.club?.title || clubData?.club_info?.title || "Club"}</Typography>
          <Typography sx={{ fontSize: 13, color: consoleColors.muted }}>Joining code {stats.club?.code || clubData?.club_info?.code || "—"}</Typography>
        </Box>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <AccountBalanceWallet sx={{ color: consoleColors.muted }} />
          <Typography sx={{ fontSize: 20, fontWeight: 750 }}>₹{formatAmount(stats.club?.wallet_amount ?? clubData?.club_info?.wallet_amount)}</Typography>
        </Box>
      </Box>
      <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr", lg: "repeat(3, 1fr)" }, gap: 1.5 }}>
        {cards.filter((card) => hasMenu(clubData, card.menu)).map((card) => {
          const Icon = card.icon;
          return (
            <Box
              key={card.key}
              onClick={() => navigate(card.to)}
              sx={{
                background: "#fff",
                border: `1px solid ${consoleColors.line}`,
                borderRadius: 2.5,
                p: 2,
                cursor: "pointer",
                display: "flex",
                gap: 1.5,
                alignItems: "center",
                "&:hover": { borderColor: "#cbd5e1", boxShadow: "0 8px 20px rgba(15,23,42,0.06)" },
              }}
            >
              <Box sx={{ width: 42, height: 42, borderRadius: 2, background: card.tint, color: card.color, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                <Icon sx={{ fontSize: 22 }} />
              </Box>
              <Box>
                <Typography sx={{ fontSize: 24, fontWeight: 700, color: consoleColors.ink, lineHeight: 1 }}>{stats[card.key] ?? 0}</Typography>
                <Typography sx={{ fontSize: 13, color: consoleColors.muted, mt: 0.4 }}>{card.label}</Typography>
              </Box>
            </Box>
          );
        })}
      </Box>
    </Box>
  );
}
